import { ComputedTask, DepType } from '../types/types';
import { ROW_H } from '../constants';

interface DepLineProps {
  from: ComputedTask;
  to: ComputedTask;
  fromRow: number;
  toRow: number;
  type: DepType;
  xOf: (date: Date) => number;
}

export default function DepLine({ from, to, fromRow, toRow, type, xOf }: DepLineProps) {
  const yc = (row: number) => row * ROW_H + ROW_H / 2;
  const fy = yc(fromRow);
  const ty = yc(toRow);

  const fx = type === 'SS' || type === 'SF' ? xOf(from.start) : xOf(from.end);
  const tx =
    type === 'SS' || type === 'FF'
      ? xOf(to.start)
      : type === 'SF'
      ? xOf(to.end)
      : xOf(to.start);

  const G = 10;
  const endX = tx;
  let d: string;

  if (endX > fx + G) {
    d = `M ${fx} ${fy} L ${fx + G} ${fy} L ${fx + G} ${ty} L ${endX} ${ty}`;
  } else {
    const back = fx + G;
    const midY = ty > fy ? ty - ROW_H / 2 : ty + ROW_H / 2;
    d = `M ${fx} ${fy} L ${back} ${fy} L ${back} ${midY} L ${endX - G} ${midY} L ${endX - G} ${ty} L ${endX} ${ty}`;
  }

  return <path d={d} fill="none" stroke="#9aa0a6" strokeWidth={1.4} markerEnd="url(#arrow)" />;
}